<template>
  <div></div>
</template>

<script>
import { mapState } from "vuex";

export default {
  metaInfo() {
    return {
      title: this.websiteName,
      meta: [
        { name: "description", content: this.description },
        { name: "keywords", content: this.keywords },
        { property: "og:title", content: this.websiteName },
        // 其他 meta 标签...
      ],
    };
  },
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      templete: "",
      isRouterAlive: true,
      websiteName: "",
      description: "",
      keywords: "",
    };
  },
  components: {
    // Header,
    // Footer,
  },
  computed: {
    ...mapState({
      //查询首页模板名称
      webSetting: (state) => state.index.webSetting,
    }),
  },
  mounted() {
    // this.checkIfWechatBrowser();
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      let data = {};

      //查询租户模板信息
      this.$store.dispatch("index/getWebSetting", data).then(() => {
        this.$router.push(this.webSetting.router);
      });
    },
  },
};
</script>
